<template>
    <div class="successWrap">
        <div class="logo"></div>
        <div class="successText">{{$t('success.successText')}}</div> 
        <div class="text" v-html="$t('success.text')+actAnimal.name+$t('success.trainer')"></div>
        <!--中间的大图-->
        <div class="success_bj">
            <div class="headPic"><img :src="actAnimal.headImg" alt=""></div>
            <div class="diploma"><img src="../assets/img/diploma.png" alt=""></div>
            <div class="animalName">{{actAnimal.name}}</div>
        </div>
        <div class="play" @click="$router.push('/')">{{$t('success.playAgain')}}</div>
      <!--understand more部分-->
        <div class="understand" @click="toWebsite();">
            <div class="understandTitle">{{$t('success.understandTitle')}}</div>
            <div class="website">
                <img src="../assets/img/website_1.png" alt="">
                <img src="../assets/img/website_2.png" alt="">
                <img src="../assets/img/website_3.png" alt="">
            </div>
            <div class="link">https://www.wennoanimal.com/web/</div>
        </div>
      <!--APP Download部分-->
        <div class="download">
            <div class="downloadTitle">{{$t('success.downloadTitle')}}</div>
            <div class="appStore">
                <div class="storeItem" @click="toAppStore('google');">
                    <img src="../assets/img/google.png" alt="">
                    <span>{{$t('success.google')}}</span>
                </div>
                <div class="storeItem" @click="toAppStore('apple');">
                    <img src="../assets/img/apple.png" alt="">
                    <span>{{$t('success.apple')}}</span>
                </div>
                <div class="storeItem" @click="toAppStore('huawei');">
                    <img src="../assets/img/huawei.png" alt="">
                    <span>{{$t('success.huawei')}}</span>
                </div>
                <div class="storeItem" @click="toAppStore('xiaomi');">
                    <img src="../assets/img/mi.png" alt="">
                    <span>{{$t('success.xiaomi')}}</span>
                </div>                
            </div>
        </div>
  </div>
</template>

<script>
    export default {
        data(){
            return{
                actAnimal:{
                    type:'meat',
                    name:this.$t('animals.lion'),
                    headImg:this.$modelUrl+'/static/img/head/Badges_lion.png',
                    blackHeadImg:this.$modelUrl+'/static/img/head/balck_lionn.png',
                },
            }
        },
        mounted(){
        },
        methods:{
            toWebsite(){
                window.open('https://www.wennoanimal.com/web/');
            },
            toAppStore(store){
                console.log(store);
                switch (store) {
                    case 'google':
                        window.open('https://play.google.com/store/apps/details?id=com.wennoanimal.wenno');
                        break;
                    case 'apple':
                        window.open('https://itunes.apple.com/us/app/wenno/id1071091237?ls=1&mt=8');
                        break;
                    case 'huawei':
                        window.open('https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C100606435?source=appshare&subsource=C100606435&shareTo=weixin&locale=zh_CN');
                        break;
                    case 'xiaomi':
                        window.open('http://app.xiaomi.com/details?id=com.wennoanimal.wenno&from=singlemessage&isappinstalled=0');
                        break;
                    default:
                        window.open('http://47.75.178.168/uploads/download/Wenno.apk');
                        break;
                }
            }
        },
    }
</script>

<style scoped>
    .successWrap{
        background: url('../assets/img/result_bj.png')  no-repeat;
        background-size: cover; 
        overflow: hidden;
    }
    .successText{
        text-align: center;
        margin-top: 20px;
        font-size: 94px;
        color: #AA723C;
        font-weight: 700;
        text-shadow:5px 5px 8px #fff,
                    -5px 5px 8px #fff,
                    -5px -5px 8px #fff,
                    5px -5px 8px #fff;
    }
    .text{
        color: #fff;
        font-size: 40px;
        text-align:center;
        
    }
    .success_bj{
        width: 388px;
        height: 454px;
        background: url('../assets/img/Result_page.png') no-repeat;
        background-size: cover;
        margin:31px auto;
        position: relative;
    }
    .headPic img{
        height: 268px;
        width: 268px;  
        margin-top: 40px;
        flex: auto 0;
    }
    .headPic{
        height: 268px;
        width: 268px; 
        margin: 0 auto;
    }

    .diploma img{
        width: 134px;
        height: auto;
        position: absolute;
        left: 274px;
        top:-20px;
    }
    .animalName{
        font-size: 56px;
        color: #AA723C;
        text-align: center;
        margin-top: 50px;
    }
    
    .otherText{
        color: #fff;
        font-size: 40px;
        text-align: center;
    }

    /*其他动物图片*/
    .otherPic{
        display: flex;
        justify-content: space-between;
        padding: 30px 20px;
    }
    .otherPic img{
        width: 150px;
        height: 150px;
        border-radius: 50%;
    }
    .nextImg{
        box-shadow: -5px 0px 5px #FF9F39, /*左边阴影*/              
                    0px -5px 5px #FF9F39,/*上边阴影*/               
                    5px 0px 5px #FF9F39,  /*右边阴影*/  
                    0px 5px 5px #FF9F39; /*下边阴影*/      
    }

    /*continue*/
    .continue{
        width: 642px;
        height: 392px;
        background: url('../assets/img/continue_bj.png') no-repeat ;
        background-size: cover;
        margin: 50px auto;
        position: relative;
    }
    .continueTitle{
        width: 374px;
        height: 118px;
        background: url('../assets/img/title.png') no-repeat;
        background-size: cover;
        position: absolute;
        top:-40px;
        left: 50%;
        margin-left: -187px;
        text-align: center;
        line-height: 118px;
        color: #fff;
        font-size: 40px;
        font-weight: 700;
    }

    .continue_star{
        margin-top: 150px;
        margin-left: 97px;
        width: 448px;
        height: 68px;
    }
    /*continue中间头像*/
    .continuePic{
        width: 180px;
        height: 180px;
        position: absolute;
        top: 94px;
        left: 50%;
        margin-left: -90px;

    }

    /*understand more部分*/
    .understand{
        width: 642px;
        height: 392px;
        background: url('../assets/img/continue_bj.png') no-repeat ;
        background-size: cover;
        margin: 90px auto;
        position: relative;
    }
    .understandTitle{
        width: 374px;
        height: 118px;
        background: url('../assets/img/title.png') no-repeat;
        background-size: cover;
        position: absolute;
        top:-40px;
        left: 50%;
        margin-left: -187px;
        text-align: center;
        line-height: 118px;
        color: #fff;
        font-size: 36px; 
        font-weight: 700;
    }
    .website{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 95px 40px 0;
    }
    .website img{
        width: 175px;
        height: 162px;
    }
    .link{
        color: #AA723C;
        font-size: 30px;
        margin-top: 28px;
        text-align: center;
    }
    
    /*app download部分*/
    .download{
        width: 642px;
        height: 392px;
        background: url('../assets/img/continue_bj.png') no-repeat ;
        background-size: cover;
        position: relative;
        left: 50%;
        margin-left: -321px;
        
    }
    .downloadTitle{
        width: 374px;
        height: 118px;
        background: url('../assets/img/title.png') no-repeat;
        background-size: cover;
        position: absolute;
        top:-40px;
        left: 50%;
        margin-left: -187px;
        text-align: center;
        line-height: 118px;
        color: #fff;
        font-size: 40px; 
        font-weight: 700;
    }
    .appStore{
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        justify-content: space-around;
        width: 600px;
        margin-left: 21px;
        padding-top: 126px; 
        
    }
    .storeItem{
        width: 210px;
        height: 60px;
        margin-bottom: 30px;
        line-height: 60px;
        color: #fff;
        background: #000;
        border-radius: 20px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        border: 3px solid #fff;
    }
    .storeItem>img{
        height: 50px;
        width: 50px;
        margin-left: 10px;
    }
    .storeItem>span{
        margin-left: 10px;
        font-size: 28px;
    }
    .logo{
        width: 180px;
        height: 120px;
        margin-left: 20px;
        margin-top: 20px;
        background: url('../assets/img/logo.png') no-repeat;
        background-size: 100% 100%;
    }
    .play{
        width: 374px;
        height: 118px;
        background: url('../assets/img/title.png') no-repeat;
        background-size: cover;
        margin: 30px auto;
        line-height: 118px;
        text-align: center;
        color: #fff;
        font-size: 40px; 
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/Success.vue